<template>
  <div class="articleWrapper">
    <div>
      Datepicker
      <DatePicker v-model="date" name="uniquename"></DatePicker>
    </div>
    <div>
      <input type="file" @change="processFile($event)" />
      <img :src="imageUrl" class="preview" />
    </div>
    <div>
      Is this published ?
      <input type="checkbox" v-model="checkPusblished" />
    </div>
    <div>
      Is in a adventure ?
      <input type="checkbox" v-model="check" />
    </div>
    <div v-if="check">
      <select v-model="selectedAd">
        <option :key="c.ownId" v-for="c in getAllAdventuresList" :value="c.ownId">{{c.title}}</option>
      </select>
    </div>

    <div>
      Desc:
      <input type="text" v-model="desc" />
    </div>
    <div>
      Title:
      <input v-model="title" />
    </div>

    <select v-model="selected">
      <option :key="c.country" v-for="c in getAllCountriesList" :value="c.country">{{c.name}}</option>
    </select>
    <select v-model="selectedCon">
      <option :key="con.code" v-for="con in getAllContinentsList" :value="con.code">{{con.name}}</option>
    </select>
    <LMap id="mapid2" :center="center" :zoom="zoom" v-on:click="addMarker">
      <LTileLayer :url="url"></LTileLayer>
      <LMarker
        :key="index"
        v-for="(marker, index) in markers"
        :lat-lng="marker"
        @click="removeMarker(index)"
      ></LMarker>
    </LMap>
    <vue-editor
      class="vueEditorFixHeight"
      v-model="content"
      useCustomImageHandler
      @image-added="handleImageAdded"
    ></vue-editor>
    <md-button @click="format()">FORMAT</md-button>
    <md-button @click="method()">Create</md-button>
    <md-button @click="onDelete()" v-if="this.truc && this.truc.ownId">Delete {{warning}}</md-button>
  </div>
</template>

<script>
// @ is an alias to /src
import { VueEditor } from "vue2-editor";
import { mapActions, mapGetters } from "vuex";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import DatePicker from "vuejs-datepicker";
import { formatTextForImages } from "../../utils";
export default {
  name: "me",
  components: {
    VueEditor,
    LMap,
    LTileLayer,
    LMarker,
    DatePicker
  },
  mounted() {
    this.method = this.onCreateArticle;
    if (this.truc) {
      this.date = new Date(this.truc.date);
      this.method = this.onUpdateArticle;
      this.content = this.truc.content;
      this.desc = this.truc.desc;
      this.title = this.truc.title;
      this.imageUrl = this.truc.image;
      this.selected = this.truc.country;
      this.selectedCon = this.truc.continent;
      this.checkPusblished = !!this.truc.published;
      this.markers = this.truc.markers.map(({ lat, lng }) => [lat, lng]);
      if (this.truc.adventure) {
        this.check = true;
        this.selectedAd = this.truc.adventure;
      }
    }
  },
  data() {
    return {
      checkPusblished: false,
      content: "",
      selected: "",
      title: "",
      desc: "",
      selectedCon: "",
      center: [47.41322, -1.219482],
      zoom: 4,
      markers: [],
      check: false,
      selectedAd: undefined,
      imageUrl: null,
      method: null,
      date: null,
      warning: undefined,
      url:
        "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
    };
  },
  props: ["truc"],
  methods: {
    ...mapActions([
      "addArticle",
      "deleteArticle",
      "uploadImage",
      "updateArticle",
      "setArticle"
    ]),
    format() {
      this.content = formatTextForImages(this.content);
    },
    async onCreateArticle() {
      const data = {
        country: this.selected,
        content: this.content,
        title: this.title,
        continent: this.selectedCon,
        markers: this.markers.map(m => ({
          lat: m[0],
          lng: m[1]
        })),
        desc: this.desc,
        image: this.imageUrl,
        date: this.date,
        published: this.checkPusblished
      };
      if (this.check && this.selectedAd) {
        data.adventure = this.selectedAd;
      }

      await this.addArticle(data);
      this.$router.push("/dashboard");
    },
    removeMarker(i) {
      this.markers.splice(i, 1);
    },
    addMarker(e) {
      console.log(e);
      this.markers.push([e.latlng.lat, e.latlng.lng]);
    },
    async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      const { url } = await this.uploadImage(file);
      Editor.insertEmbed(cursorLocation, "image", url);
      resetUploader();
    },
    async processFile(event) {
      var file = event.target.files[0];
      const { url } = await this.uploadImage(file);
      this.imageUrl = url;
    },
    async onUpdateArticle() {
      const data = {
        country: this.selected,
        content: this.content,
        title: this.title,
        continent: this.selectedCon,
        markers: this.markers.map(m => ({
          lat: m[0],
          lng: m[1]
        })),
        desc: this.desc,
        image: this.imageUrl,
        date: this.date.getTime(),
        published: !!this.checkPusblished
      };
      if (this.check && this.selectedAd) {
        data.adventure = this.selectedAd;
      }
      await this.updateArticle({ article: data, ownId: this.truc.ownId });
      this.$router.push("/dashboard");
    },
    async onDelete() {
      if (!this.warning) {
        this.warning = "(Click again to confirm deletion)";
        return;
      }
      await this.deleteArticle(this.truc.ownId);
      this.$router.push("/dashboard");
    }
  },
  computed: {
    ...mapGetters([
      "getAllContinentsList",
      "getAllCountriesList",
      "getAllAdventuresList"
    ])
  }
};
</script>

<style >
#mapid2 {
  height: 500px;
  margin-top: 200px;
}
.addBtn {
  background-color: white;
  color: black;
  height: 50px;
  margin: 10px;
}
.addBtn:hover {
  cursor: pointer;
}

.articleWrapper {
  background-color: white;
  color: black;
}

.preview {
  max-height: 30px;
}
</style>
